var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayTechnicalAlert)?_c('div',{attrs:{"id":"technicalAlertBlock"}},[_c('span',{attrs:{"id":"technicalAlertContent"}},[_vm._v(_vm._s(_vm.$t("technical_alert_text")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }